// Content Backlog API — CONTENTBACKLOG CRUD via AppSync BACKLOG_ACTION job type.
// Follows reporterAgentApi.js / advertisingAgentApi.js pattern:
// clean Apollo client, auth via JWT, all operations through triggerAdAgencyJob mutation.
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { TRIGGER_AD_AGENCY_JOB_MUTATION } from "../queries/libraryCardQueries";
import { getAuthToken } from "../utils/authUtils";

const GRAPHQL_ENDPOINT = "https://m2jxbyhagffjthxtsiuwb2iiwe.appsync-api.us-east-1.amazonaws.com/graphql";

const httpLink = createHttpLink({ uri: GRAPHQL_ENDPOINT });

const authLink = setContext((_, { headers }) => {
  const token = getAuthToken();
  return {
    headers: { ...headers, ...(token ? { Authorization: token } : {}) },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

async function backlogAction(tenantId, action, payload = {}) {
  const { data } = await client.mutate({
    mutation: TRIGGER_AD_AGENCY_JOB_MUTATION,
    variables: {
      input: {
        jobType:  "BACKLOG_ACTION",
        tenantId,
        payload:  JSON.stringify({ action, ...payload }),
      },
    },
  });
  const raw = data.triggerAdAgencyJob;
  // Sync Lambda result is JSON-stringified in the `result` field
  return raw?.result ? JSON.parse(raw.result) : raw;
}

// Add a new item to the content backlog
export const addToBacklogApi = (tenantId, payload) =>
  backlogAction(tenantId, "ADD_TO_BACKLOG", payload);

// Fetch all backlog items for the tenant
export const listBacklogApi = (tenantId) =>
  backlogAction(tenantId, "LIST_BACKLOG");

// Mark a backlog item as posted (after CoWork posts it to LinkedIn)
export const markAsPostedApi = (tenantId, backlogId) =>
  backlogAction(tenantId, "MARK_AS_POSTED", { backlogId });
